/**
 * Endpoint methods related to Sparkfore Admin
*/
import API from "./Api";

export default {

  async login(form) {
    // await Csrf.getCookie();

    return API.post("/admin/auth", form);
  }

}